import styled from 'styled-components'

const getBackgroundGradient = (props) => {
    // if (typeof props.backgroundColor === 'string') {
    //   return props.backgroundColor
    // }
    if (props.backgroundColor.type === 'color') {
      return props.backgroundColor.colorValue;
    } else {
        let gradient = '';
        props.backgroundColor.gradientLayers.map((layer, index) => {
            gradient = `linear-gradient(${layer.angle}deg, ${layer.firstColor}, ${layer.secondColor} ${layer.transition}%)` + gradient
            if (index != props.backgroundColor.gradientLayers.length - 1) {
                gradient = ', ' + gradient
            }
        })
        return gradient
    }
  }

export const GetSlide = (props) => {
    const Slide = styled.div`
        box-shadow: ${props.hasShadow ? props.backgroundShadow : null};
        height: ${props.height}px;
        /* background: ${props.background}; */
        background: ${getBackgroundGradient(props)};
        /* background-size: cover; */
        background-repeat: no-repeat;
        /* background-position-y: ${props.parallaxPosition}px; */
        /* transition: transform .1s; */

    `


    return (
        <Slide className={props.className}>
            {props.children}
        </Slide>
    )
}

export const SlideContainer = styled.div`
    position: relative;
    overflow: hidden;
`


